// NirmalX pages style their own links (CSS modules), so they use next/link rather than the Chakra-styled Link.
// eslint-disable-next-line no-restricted-imports
import NextLink from 'next/link';
import React from 'react';

import { useLiveHome, useNow } from '../hooks';
import { HORIZON, SHOW_HYPE_BANNER } from '../nirmalx';
import BlockStream from './BlockStream';
import Hero from './Hero';
import css from './home.module.css';
import HypeBanner from './HypeBanner';
import LiveDeck from './LiveDeck';
import TxStream from './TxStream';

/** The NirmalX explorer home: sunrise hero with search, the mainnet teaser (testnet only), live chain, and what's next. */
const NirmalxHome = () => {
  const now = useNow();
  const { stats, blocks, txs, freshHeight } = useLiveHome();
  const latest = blocks.data?.[0];

  return (
    <div className={ css.home }>
      <Hero latest={ latest } now={ now }/>
      { SHOW_HYPE_BANNER && <HypeBanner/> }

      <section className={ css.section }>
        <span className={ css.eyebrow }>Live network</span>
        <h2 className={ css.sectionTitle }>The chain, breathing in real time.</h2>
        <LiveDeck stats={ stats.data } blocks={ blocks.data } now={ now }/>
      </section>

      <section id="stream" className={ css.section }>
        <div className={ css.sectionHead }>
          <div>
            <span className={ css.eyebrow }>Latest blocks</span>
            <h2 className={ css.sectionTitle }>Sealed, linked, final.</h2>
          </div>
          <NextLink className={ css.textLink } href={{ pathname: '/blocks' }}>All blocks →</NextLink>
        </div>
        <BlockStream blocks={ blocks.data } freshHeight={ freshHeight } now={ now }/>
      </section>

      <section className={ css.section }>
        <div className={ css.sectionHead }>
          <div>
            <span className={ css.eyebrow }>Latest transactions</span>
            <h2 className={ css.sectionTitle }>Value in motion.</h2>
          </div>
          <NextLink className={ css.textLink } href={{ pathname: '/txs' }}>All transactions →</NextLink>
        </div>
        <TxStream txs={ txs.data } isLoading={ txs.isPending } now={ now }/>
      </section>

      <section id="horizon" className={ css.section }>
        <span className={ css.eyebrow }>On the horizon</span>
        <h2 className={ css.sectionTitle }>What&apos;s coming to NirmalX.</h2>
        <div className={ css.horizonGrid }>
          { HORIZON.map((item, index) => (
            <article key={ item.title } className={ css.horizonCard }>
              <div className={ css.horizonIndex }>{ String(index + 1).padStart(2, '0') }</div>
              <span className={ css.horizonStatus }>{ item.status }</span>
              <h3 className={ css.horizonTitle }>{ item.title }</h3>
              <p className={ css.horizonText }>{ item.text }</p>
            </article>
          )) }
        </div>
      </section>
    </div>
  );
};

export default NirmalxHome;
